export default __webpack_public_path__ + "static/media/supper_apps_xl3.949eae0c.png";